import { IGetPageSizeUseCase } from "../../../presentation/useCases/read/get_page_size_use_case";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * IGetPageSizeUseCase
 */

export class GetPageSizeUseCase implements IGetPageSizeUseCase {
  constructor(
    private readonly repository: ICommonsRepository,
  ) { }

  async getPageSize(idPage: number): Promise<number> {
    return this.repository.getPageSize(idPage);
  }
}